import { Node } from './types';

export const emit = (node: Node): string => {
  const emitAndChild = (child: Node): string =>
    child.type === 'or' ? `( ${emit(child)} )` : emit(child);

  const emitOrChild = (child: Node): string =>
    child.type === 'and' ? `( ${emit(child)} )` : emit(child);

  const emitNotChild = (child: Node): string =>
    child.type === 'term' ? emit(child) : `( ${emit(child)} )`;

  switch (node.type) {
    case 'term':
      return `"${node.value}"`;
    case 'and':
      return node.children.map(emitAndChild).join(' ');
    case 'or':
      return node.children.map(emitOrChild).join(' OR ');
    case 'not':
      return `-${emitNotChild(node.child)}`;
    default:
      return '';
  }
};
